// extracted by mini-css-extract-plugin
export default {"ecom-header":"yI6r0V","ecomHeader":"yI6r0V"};